import React from 'react';
import { cn } from '../lib/utils';

const sizeMap = {
  sm: 'text-2xl',
  md: 'text-3xl',
  lg: 'text-4xl',
  xl: 'text-5xl md:text-6xl',
  '2xl': 'text-6xl md:text-7xl lg:text-8xl',
};

export const GlassTitle = ({ children, as: Tag = 'h1', size = 'xl', className }) => (
  <Tag className={cn('font-bold tracking-tight liquid-glass', sizeMap[size], className)}>
    {children}
  </Tag>
);

export default GlassTitle;
